module.exports = __webpack_public_path__ + "static/media/check.74c40ea0.svg";